import React, { useState, useEffect } from 'react';
import { Reveal } from '../ui/Reveal';
import { APPS } from '../../data/apps';

export const Apps = () => {
  const [selected, setSelected] = useState(null);

  const close = () => setSelected(null);

  // Lock page scroll + close on Escape while the popup is open
  useEffect(() => {
    if (!selected) return;
    const onKey = (e) => { if (e.key === "Escape") close(); };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [selected]);

  return (
    <section className="sec" id="apps">
      <Reveal><div className="slabel">Our products</div></Reveal>
      <Reveal delay="1"><h2 className="stitle">Our <em>apps</em></h2></Reveal>

      {/* ── Side-by-side compact cards ── */}
      <div className="apps-grid">
        {APPS.map((app, i) => (
          <Reveal key={app.id} delay={((i % 2) + 1).toString()}>
            <div
              className="app-tile"
              style={{ borderTop: `3px solid ${app.accent}` }}
              onClick={() => setSelected(app)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setSelected(app); } }}
            >
              <div className="app-tile-top">
                <div className="app-icon" style={{ background: `${app.accent}22` }}>{app.icon}</div>
                <span
                  className="app-status"
                  style={{ color: app.statusColor, background: `${app.statusColor}18`, borderColor: `${app.statusColor}55` }}
                >
                  <span className="app-status-dot" style={{ background: app.statusColor }} />
                  {app.statusLabel}
                </span>
              </div>

              <h3 className="app-name">{app.name}</h3>
              <div className="app-tagline">{app.tagline}</div>
              <div className="app-meta">
                <span>{app.platform}</span>·<span>{app.category}</span>
              </div>

              <p className="app-tile-desc">{app.desc}</p>

              <div className="app-tile-more">View details →</div>
            </div>
          </Reveal>
        ))}
      </div>

      {/* ── Details popup ── */}
      <div
        className={`amodal-overlay${selected ? " open" : ""}`}
        onClick={(e) => { if (e.target.classList.contains("amodal-overlay")) close(); }}
      >
        {selected && (
          <div className="amodal" style={{ borderTop: `3px solid ${selected.accent}` }}>
            <button className="amodal-close" onClick={close} aria-label="Close">✕</button>

            <div className="app-head">
              <div className="app-icon" style={{ background: `${selected.accent}22` }}>{selected.icon}</div>
              <div className="app-head-text">
                <div className="app-name-row">
                  <h3 className="app-name">{selected.name}</h3>
                  <span
                    className="app-status"
                    style={{ color: selected.statusColor, background: `${selected.statusColor}18`, borderColor: `${selected.statusColor}55` }}
                  >
                    <span className="app-status-dot" style={{ background: selected.statusColor }} />
                    {selected.statusLabel}
                  </span>
                </div>
                <div className="app-tagline">{selected.tagline}</div>
                <div className="app-meta">
                  <span>{selected.platform}</span>·<span>{selected.category}</span>·<span>{selected.developer}</span>
                </div>
              </div>
            </div>

            <p className="app-desc">{selected.desc}</p>

            {selected.screenshots.length > 0 && (
              <div className="app-shots">
                {selected.screenshots.map(s => (
                  <figure className="app-shot" key={s.src}>
                    <img src={s.src} alt={`${selected.name} – ${s.label}`} loading="lazy" />
                    <figcaption>{s.label}</figcaption>
                  </figure>
                ))}
              </div>
            )}

            {selected.features.length > 0 && (
              <div className="app-features">
                {selected.features.map(f => (
                  <div className="app-feature" key={f.title}>
                    <div className="app-feature-ico">{f.icon}</div>
                    <div className="app-feature-title">{f.title}</div>
                    <div className="app-feature-desc">{f.desc}</div>
                  </div>
                ))}
              </div>
            )}

            <div className="app-foot">
              <a
                className="app-cta"
                href={selected.cta.href}
                target={selected.cta.href.startsWith("http") ? "_blank" : "_self"}
                rel="noreferrer"
              >
                {selected.cta.label} →
              </a>
              {selected.disclaimer && <p className="app-disclaimer">{selected.disclaimer}</p>}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};